const CardContainer = ({ children }) => {
    return (
        // w-full solo mobile: gli antenati (PageContainer items-center) sono fit-content,
        // quindi senza larghezza esplicita la griglia si dimensiona sul max-content delle
        // card — con pochi risultati dai testi corti la card singola usciva stretta.
        // Da md in su torna w-auto: la griglia compatta centrata del desktop non cambia.
        <div className="w-full md:w-auto grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-4">
            {children}
        </div>
    )
}

export default CardContainer